<div class="div-wrap">
  <div class="header">
      <div class="logo">
      </div>
  </div>

  <div class="content">
      <!-- <img src="assets/images/no-unauthorizedsign.png" title="Unauthorized:Access......" style="max-height:20rem" /> -->
      <p><span><label></label>Unauthorized: Access.</span>You do not have permission to view this directory or page.</p>

      <a (click)="Login()">Back To Login</a>
  </div>
  <!--End-Cotent------>
</div>